export default __webpack_public_path__ + "toggle-navigation.9c51c750ce26c4490d07.svg";